import { embed, Executor } from "@/js/auth/recaptcha";
import { PluginFunction } from "vue";

declare module "vue/types/vue" {
  // Add the $axios property on every vue instance.
  interface Vue {
    $recaptcha: Executor;
  }
}

interface RecaptchaPluginOptions {
  siteKey: string
}

const plugin: PluginFunction<RecaptchaPluginOptions> = async (Vue, options) => {
  if (!options) {
    throw "ReCaptcha plugin requires a siteKey";
  }
  const executer = await embed(options.siteKey);
  Vue.prototype.$recaptcha = executer;
};

export default plugin;
